import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { isLoggedIn } from "./utils/auth";

import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Users from "./pages/Users/Users";
import Operators from "./pages/Operators/Operators";
import Leads from "./pages/Leads/Leads";
import Config from "./pages/Config/Config";
import Audit from "./pages/Audit/Audit";
import Layout from "./components/Sidebar/Layout";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import Demo from "./pages/Demo/Demo";
import Attendance from "./pages/Attendance/Attendance";
import Unauthorized from "./pages/Unauthorized/Unauthorized";
import UserProfile from "./pages/Users/UserProfile";

const PrivateRoute = ({ children }) =>
  isLoggedIn() ? children : <Navigate to="/login" replace />;

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="operators" element={<Operators />} />
          <Route path="leads" element={<Leads />} />
          <Route path="config" element={<Config />} />
          <Route path="audit" element={<Audit />} />
          <Route path="demos" element={<Demo />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="user/profile" element={<UserProfile />} />
          <Route path="user/:id" element={<UserProfile />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
